











import { Vue, Component } from 'vue-property-decorator';
import { appName } from '@/env';
import { store } from '@/store';
import { dispatchCheckLoggedIn } from '@/store/main/actions';
import { readIsLoggedIn } from '@/store/main/getters';
import NavBar from '@/components/NavBar.vue';

const startRouteGuard = async (to, from, next) => {
  await dispatchCheckLoggedIn(store);
  if (readIsLoggedIn(store)) {
    if (to.path === '/login') {
      next('/home');
    } else {
      next();
    }
  } else if (readIsLoggedIn(store) === false) {
    if (to.path !== '/login') {
      sessionStorage.setItem('redirectPath', to.fullPath);
      next('/login');
    } else {
      next();
    }
  }
};

@Component({
  components: {
    NavBar
  },
  metaInfo() {
    return {
      title: 'Home',
      titleTemplate: '%s | Demessemaeker'
    };
  }
})
export default class Main extends Vue {
  public appName = appName;

  public beforeRouteEnter(to, from, next) {
    startRouteGuard(to, from, next);
  }

  public beforeRouteUpdate(to, from, next) {
    startRouteGuard(to, from, next);
  }

  public get isLoggedIn() {
    return readIsLoggedIn(this.$store);
  }
}
